import {useEffect,useState} from 'react';
import {useSearchParams} from 'react-router';
import {supplierStatuses,type SupplierStatus as Status} from '@myfm/domain';
import {Link} from '../ui/ScopedLink';
import {api} from '../api';
import {formatDateOnly} from '../dates';
import {useStaffSession} from '../ui/StaffSession';
import {withBuildingScope} from '../ui/building-scope';
import {CountChips} from '../ui/CountChips';
import {DataTable} from '../ui/DataTable';
import {PageHeader} from '../ui/PageHeader';
import {Empty,ErrorState,Loading} from '../ui/State';

type Supplier={organisationId:string;name:string;contractorStatus:string|null;supplierStatus:string|null;status:Status;evidenceGaps:string[];insuranceExpires:string|null};
type Data={suppliers:Supplier[];counts:Record<Status,number>};

// Register programme G6 (owner decision, 5 Oct 2026): one status per supplier, from the same
// evidence rules procurement uses.
export function SupplierStatus(){
 const scope=useStaffSession()?.effectiveScope,building=scope?.kind==='building'?scope.id:undefined;
 const [data,setData]=useState<Data>(),[error,setError]=useState<unknown>(),[params]=useSearchParams();
 const filter=supplierStatuses.find(s=>s===params.get('status'));
 useEffect(()=>{api<Data>(building?`/api/supplier-status?building=${building}`:'/api/supplier-status').then(setData).catch(setError);},[building]);
 if(error)return <ErrorState error={error}/>;if(!data)return <Loading/>;
 const shown=filter?data.suppliers.filter(s=>s.status===filter):data.suppliers;
 const href=(status?:Status)=>withBuildingScope(status?`/work/supplier-status?status=${encodeURIComponent(status)}`:'/work/supplier-status',building);
 return <>
  <PageHeader title="Supplier status" {...(scope?.kind==='building'?{scope:{kind:'building' as const,name:scope.name}}:{})} context="Approved means approved for at least one service with every mandatory document current, including insurance."/>
  <CountChips ariaLabel="Supplier statuses" keys={['status']} items={[{label:'All',count:data.suppliers.length,to:href()},...supplierStatuses.filter(s=>data.counts[s]).map(s=>({label:s,count:data.counts[s],to:href(s),...(s==='Evidence expired or missing'||s==='Not approved'?{tone:'warning' as const}:{})}))]}/>
  {shown.length===0?<Empty>No suppliers in this view.</Empty>:<DataTable caption="Suppliers and their status" scrollLabel="Suppliers" rows={shown} getRowKey={s=>s.organisationId}
   rowHeader={{id:'name',header:'Supplier',render:s=><Link to={withBuildingScope(`/records/organisation/${s.organisationId}`,building)}>{s.name}</Link>}}
   columns={[{id:'status',header:'Status',render:s=>s.status},{id:'insurance',header:'Insurance current until',render:s=>formatDateOnly(s.insuranceExpires,'—')},
    {id:'gaps',header:'Missing or expired',render:s=>s.evidenceGaps.join(', ')||'—'}]}/>}
 </>;
}
